import { render, staticRenderFns } from "./BlueMenuIcon.vue?vue&type=template&id=553b66b3&"
import script from "./BlueMenuIcon.vue?vue&type=script&lang=js&"
export * from "./BlueMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports